import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
import "swiper/css";

let swiper = null;

const initBannersSlider = () => {
    const $container = document.querySelector('.banners-slider-block');
    if (!$container) return;

    const sliderContainer = $container.querySelector('.js-banners-slider');
    if (!sliderContainer) return;

    if (swiper) swiper.destroy(true, true);

    const isMobile = window.innerWidth < 577;

    swiper = new Swiper(sliderContainer, {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 24,
        speed: 1000,
        watchOverflow: true,
        autoHeight: isMobile,
        navigation: {
            nextEl: $container.querySelector('.js-button-banners-next'),
            prevEl: $container.querySelector('.js-button-banners-prev'),
        },
        breakpoints: {
            577: {
                spaceBetween: 24,
            },
            992: {
                spaceBetween: 60,
            },
        },
    });
};

const bannersSlider = () => {
    initBannersSlider();

    window.addEventListener('resize', () => {
        initBannersSlider();
    });
};

export default bannersSlider;
